import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment';

import { GetSoilAnalysesRequestData, SoilAnalysisByCropFieldId } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SoilAnalysisApiService {
  protected readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/fieldregistration/soilanalysis';

  getLatestSoilAnalysis(request: GetSoilAnalysesRequestData) {
    return this.http.post<{ soilAnalysisGroups: SoilAnalysisByCropFieldId[] }>(
      `${this.baseUrl}/mostrecentbypropertiesperid`,
      request,
    );
  }
}
